<template>
	<div>
		<el-card class="box-card">
			<el-form label-width="80px">
				<el-form-item label="状态:">
					<el-radio-group v-model="listQuery.search.state" @change="platformChange">
						<el-radio label="" border>全部</el-radio>
						<el-radio :label="item.value.toString()" v-for="item in state_list" border>{{item.label}}
						</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="">
					<el-row :gutter="5">
						<el-col :span="3">
							<el-select v-model="listQuery.search.shop_id" clearable placeholder="所有店铺">
								<el-option v-for="item in store_list" :key="item.id" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
						</el-col>
						<el-col :span="2">
							<el-input v-model="listQuery.search.task_id" clearable placeholder="任务ID"></el-input>
						</el-col>
						<el-col :span="3">
							<el-input v-model="listQuery.search.xd_order_num" clearable placeholder="请输入下单订单号">
							</el-input>
						</el-col>
						<el-col :span="3">
							<el-checkbox v-model="listQuery.search.no_c" label="1" border>显示未设置评语订单</el-checkbox>
						</el-col>
						<el-col :span="8">
							<el-date-picker v-model="listQuery.search.xd_start_time" type="date" value-format="yyyy-MM-dd" placeholder="下单开始日期">
							</el-date-picker>
							-
							<el-date-picker v-model="listQuery.search.xd_end_time" type="date" value-format="yyyy-MM-dd" placeholder="下单结束日期">
							</el-date-picker>
						</el-col>
						<el-col :span="2">
							<el-button type="success" style="margin-left:50px;" plain @click="excel"><i
									class="el-icon-download"></i>
								导出数据</el-button>
						</el-col>
					</el-row>
				</el-form-item>
				<el-button type="primary" icon="el-icon-search" @click="keySearch">搜索</el-button>
				
			</el-form>
		</el-card>
		<el-card class="box-card">
			<el-badge :value="fa_num" class="item">
				<el-popconfirm @confirm="sendGoods()" @onConfirm="sendGoods()" title="确定全部发货吗？">
					<el-button icon="el-icon-truck" type="success" slot="reference" size="medium">
						一键确认发货
					</el-button>
				</el-popconfirm>
			</el-badge>
		</el-card>
		<div style="margin-top:30px">
			<el-table v-loading="loading" :data="data_list" stripe style="width: 100%" size="small">
				<el-table-column type="expand">
					<template slot-scope="props">
						<el-form label-position="left" inline class="demo-table-expand">
							<!-- <el-form-item label="下单账号:">
								<span>{{props.row.xd_user}}</span>
							</el-form-item> -->
							<el-form-item label="下单订单号:">
								<span>{{props.row.xd_order_num}}</span>
							</el-form-item>
							<el-form-item label="下单金额(含运费):">
								<span v-if="props.row.xd_order_money">{{props.row.xd_order_money}}
									({{props.row.coin_name}})</span>
							</el-form-item>
							<el-form-item label="运费:">
								<span v-if="props.row.xd_order_money">{{props.row.xd_fs_money}}
									({{props.row.coin_name}})</span>
							</el-form-item>
							<!-- <el-form-item label="下单截图:">
								<el-image v-if="props.row.xd_imgs" v-for="item in props.row.xd_imgs"
									style="width: 40px; height: 40px" :src="item" fit="fill" :preview-src-list="[item]">
								</el-image>
							</el-form-item> -->
							<el-form-item label="领取时间:">
								<span>{{ props.row.create_time | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span>
							</el-form-item>
							<el-form-item label="下单时间:">
								<span>{{ props.row.xd_time | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span>
							</el-form-item>
							<el-form-item label="发货时间:">
								<span>{{ props.row.send_time | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span>
							</el-form-item>
							<el-form-item label="确认收货时间:">
								<span>{{ props.row.sh_time | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span>
							</el-form-item>
							<el-form-item label="评语:">
								<span>{{props.row.comment}}</span>
							</el-form-item>
							<el-form-item label="评语图片:">
								<el-image v-if="props.row.comment_imgs" v-for="item in props.row.comment_imgs"
									style="width: 40px; height: 40px" :src="item" fit="fill" :preview-src-list="[item]">
								</el-image>
							</el-form-item>
							<!-- <el-form-item label="评论截图:">
								<el-image v-if="props.row.pl_imgs" v-for="item in props.row.pl_imgs"
									style="width: 40px; height: 40px" :src="item" fit="fill" :preview-src-list="[item]">
								</el-image>
							</el-form-item> -->
							<el-form-item v-if="props.row.pl_time" label="评论时间:">
								<span>{{ props.row.pl_time | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span>
							</el-form-item>
						</el-form>
					</template>
				</el-table-column>
				<el-table-column prop="id" label="ID"> </el-table-column>
				<el-table-column prop="task_id" label="任务ID"> </el-table-column>
				<el-table-column prop="goods_img" label="商品图">
					<template slot-scope="{row}">
						<el-image v-if="row.goods_img" style="width: 40px; height: 40px" :src="row.goods_img" fit="fill"
							:preview-src-list="[row.goods_img]">
						</el-image>
					</template>
				</el-table-column>
				<el-table-column prop="store_name" label="店铺"> </el-table-column>
				<el-table-column prop="goods_name" label="任务商品"> </el-table-column>
				<el-table-column prop="goods_sku" label="SKU"> </el-table-column>
				<el-table-column prop="task_money" label="任务金额(RMB)"> </el-table-column>
				<el-table-column prop="xd_order_money_rmb" label="实付金额(RMB)"></el-table-column>
				<el-table-column label="订单状态">
					<template slot-scope="{row}">
						<el-tag :type="row.state_color">
							{{ row.state_init}}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="操作" fixed="right" width="250">
					<template slot-scope="{row,$index}">
						<el-popconfirm v-if="row.state == 1" @confirm="sendGoods(row.id)" @onConfirm="sendGoods(row.id)"
							title="确定发货吗？">
							<el-button icon="el-icon-truck" type="primary" slot="reference" size="mini">发货
							</el-button>
						</el-popconfirm>
						<el-button v-if="row.state == 3" @click="pjSet(row)" icon="el-icon-chat-dot-square"
							type="warning" size="mini">评语设置</el-button>

						<el-button v-if="row.state != 9 && row.is_complain == 0" @click="ts(row)"
							icon="el-icon-chat-dot-square" type="danger" size="mini">投诉</el-button>
					</template>
				</el-table-column>
			</el-table>
			<pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.row"
				@pagination="getList" />
			<!-- 评语设置模态框 -->
			<el-dialog title="评语设置" :visible.sync="is_show_pj" width="40%">
				<el-form label-position="right" label-width="100px">
					<el-form-item label="评语:">
						<el-col :span="16">
							<el-input :rows="4" type="textarea" v-model="pj_data.comment"></el-input>
						</el-col>
					</el-form-item>
					<el-form-item label="图片(可选):">
						<el-col :span="24">
							<Img @imgList="imgsImg" :img_num="max_img_num" :img_edit="pj_data.imgs"></Img>
						</el-col>
					</el-form-item>
					<el-form-item label="视频(可选):">
						<el-col :span="24">
							<VideoU @videoList="videoUrl" :video_num="1" :max_video_size="max_video_size"
								:video_url="pj_data.video_url"></VideoU>
						</el-col>
					</el-form-item>

					<div v-if="pj_is_collocation == 1">
						<el-divider>以下是搭配商品评语设置（可选）</el-divider>
						
						<el-collapse v-model="activeNames">
							<el-collapse-item v-for="(item,i) in pj_collocation" title="搭配商品" :name="i">
								<el-form-item label="商品名称:">
									<el-col :span="16">
										<span>{{item.title}}</span>
									</el-col>
								</el-form-item>
								<el-form-item label="评语:">
									<el-col :span="16">
										<el-input :rows="4" type="textarea" v-model="item.comment"></el-input>
									</el-col>
								</el-form-item>
								<el-form-item label="图片(可选):">
									<el-col :span="24">
										<Img @imgList="imgsImgC($event,i)" :img_num="max_img_num" :img_edit="item.pj_imgs"></Img>
									</el-col>
								</el-form-item>
							</el-collapse-item>
						</el-collapse>
					</div>

				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="is_show_pj = false">返回</el-button>
					<el-button :loading="this.$store.state.ajaxLoading" type="primary" @click="pjSet2()">确定</el-button>
				</span>
			</el-dialog>
			<!-- 投诉 -->
			<el-dialog title="投诉" :visible.sync="is_show_ts" width="40%">
				<el-form label-position="right" label-width="100px">
					<el-form-item label="投诉原因:">
						<el-col :span="16">
							<el-input :rows="4" type="textarea" v-model="ts_data.cause"></el-input>
						</el-col>
					</el-form-item>

				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="is_show_ts = false">返回</el-button>
					<el-button :loading="this.$store.state.ajaxLoading" type="primary" @click="ts2()">确定</el-button>
				</span>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import {
		orderListInit,
		orderList,
		sendGoods,
		pjSet,
		orderComplain,
		excelToken
	} from '@/api/jd_task'
	import request from '@/tool/request'
	import {
		parseTime
	} from '@/tool/index'
	import Qs from 'qs'
	import Pagination from '@/components/Pagination' // 基于分页的二级包装
	import Dtp from '@/components/Ele/dateTimePicker.vue' // 时间选择组件
	import Img from '@/components/Jd/img.vue' // 上传图片组件
	import VideoU from '@/components/Jd/video.vue' // 上传视频组件
	import {
		getToken,
	} from '@/tool/cookie'
	export default {
		components: {
			Pagination,
			Dtp,
			Img,
			VideoU
		},
		data() {
			return {
				total: 0, // 总条数
				listQuery: null,
				data_list: [], // 表格数据
				loading: true,
				state_list: [],
				fa_num: 0, // 代发货的订单数量
				is_show_pj: false,
				pj_data: {},
				is_show_ts: false,
				ts_data: {},
				max_img_num: 3, // 评语最大上传图片数量
				max_video_size: 10, // 评语最大视频大小
				pj_is_collocation: 0, // 评语设置 - 订单是否有开启搭配商品
				pj_collocation: [], // 评语设置 - 搭配商品
				store_list:[], // 所有店铺
			};
		},
		filters: {
			parseTime,
		},
		created() {
			this.getListInit();
			this.resetSearchData()
			this.resetPjData();
			this.getList()
		},
		methods: {
			keySearch() { // 搜索
				this.listQuery.page = 1
				this.getList()
			},
			resetPjData() {
				this.pj_data = {
					'id': 0,
					'comment': '',
					'imgs': [],
					'video_url': ''
				};
			},
			resetTsData() {
				this.ts_data = {
					'id': 0,
					'cause': '',
				};
			},
			resetSearchData() { // 重置listQuery搜索数据
				this.listQuery = {
					page: 1,
					row: 10,
					search: {
						state: '',
						no_c: false,
					},
				}
			},
			getListInit() { // 获取列表页的其他数据
				orderListInit(Qs.stringify()).then(response => {
					let r = response.result;
					this.fa_num = r.fa_num;
					this.state_list = r.state;
					this.store_list = r.store_list;
				})
			},
			getList() { // 获取列表数据
				this.loading = true;
				orderList(Qs.stringify(this.listQuery)).then(response => {
					let r = response.result;
					this.data_list = r.items;
					this.total = r.total;
					this.max_img_num = r.max_img_num;
					this.max_video_size = r.max_video_size;
					this.loading = false;
				})
			},
			// 发货
			sendGoods(val = '') {
				sendGoods(Qs.stringify({
					'id': val
				})).then(response => {
					this.$message({
						showClose: true,
						message: '发货成功',
						type: 'success'
					});
					this.getListInit();
					this.getList();
				})
			},
			platformChange() {
				this.keySearch();
			},
			imgsImg(e) { // 用户图片调用组件时候的回调
				this.pj_data.imgs = e;
			},
			imgsImgC(e,i){ // 搭配商品图片
				this.pj_collocation[i]['pj_imgs'] = e;
			},
			videoUrl(e) { // 用户视频调用组件时候的回调
				this.pj_data.video_url = e;
			},
			// 评语设置 - 打开
			pjSet(row) {
				this.resetPjData();
				this.pj_data.id = row.id;
				this.pj_data.comment = row.comment;
				this.pj_data.imgs = row.comment_imgs_e;
				this.pj_data.video_url = row.comment_video_e;
				this.pj_is_collocation = row.is_collocation;
				this.pj_collocation = row.collocation;
				this.is_show_pj = true;
			},
			// 评语设置 - 提交
			pjSet2() {
				this.pj_data.pj_collocation = this.pj_collocation;
				this.$store.commit('setAjaxLoading', true);
				pjSet(Qs.stringify(this.pj_data)).then(response => {
					this.is_show_pj = false;
					this.$message({
						showClose: true,
						message: '设置成功',
						type: 'success'
					});
					this.getList();
				})
			},
			ts(row) {
				this.resetTsData();
				this.ts_data.id = row.id;
				this.is_show_ts = true;
			},
			ts2() {
				this.$store.commit('setAjaxLoading', true);
				orderComplain(Qs.stringify(this.ts_data)).then(response => {
					this.is_show_ts = false;
					this.$message({
						showClose: true,
						message: '提交成功，请等待处理',
						type: 'success'
					});
					this.getList();
				})
			},
			excel() {
				// 获取exceltoken
				excelToken(Qs.stringify()).then(response => {
					let token = response.result.token;
					if (token) {
						let xid = getToken('login_uid');
						let search = this.listQuery.search;
						let p = '';
						for(let s in search){
							p += '&'+s+'='+search[s];
						}
						window.open(process.env.VUE_APP_ADMIN_BASE_URL + "/TaskExcel/orderList?xid=" + xid +
							"&token=" + token + p,
							"_blank");
					}
				})
			}
		}
	}
</script>
<style>
	.el-radio {
		margin-right: 0px;
	}
</style>
